export default{
	 baseURL: 'https://mobile.baiyuehuishou.com/api/app-api',
	//baseURL: 'http://124.70.101.22:48080/app-api',
	// baseURL: 'http://192.168.31.242:48080/app-api',
}